<template>
  <div>
    <span class="section-title">{{ localize('locations.detail.about.chessFeatures.title') }}</span>
    <hr />

    <div class="additional-info">
      <div v-if="(location.chessFeatures || []).includes(LocationChessFeature.CHESS_SET)" class="info-item">
        <span class="label">
          <GamIcon :name="GamIconName.CHESS_SET" /> {{ localize('locations.detail.about.info.numOfChessSets') }}
        </span>
        <span class="value">
          <GamIcon :name="GamIconName.CHECK" class="check" />
          {{ location.chessSetCount || 'Some' }}
        </span>
      </div>

      <div v-if="(location.chessFeatures || []).includes(LocationChessFeature.CHESS_CLOCK)" class="info-item">
        <span class="label">
          <GamIcon :name="GamIconName.CHESS_CLOCK" /> {{ localize('locations.detail.about.info.numOfChessClocks') }}
        </span>
        <span class="value">
          <GamIcon :name="GamIconName.CHECK" class="check" />
          {{ location.chessClockCount || 'Some' }}
        </span>
      </div>

      <div v-if="(location.chessFeatures || []).includes(LocationChessFeature.CHESS_TABLE)" class="info-item">
        <span class="label">
          <GamIcon :name="GamIconName.CHESS_TABLE" /> {{ localize('locations.detail.about.info.numOfChessTables') }}
        </span>

        <span class="value">
          <GamIcon :name="GamIconName.CHECK" class="check" />
          {{ location.chessTableCount || 'Some' }}
        </span>
      </div>

      <div v-if="(location.chessFeatures || []).includes(LocationChessFeature.GIANT_CHESS)" class="info-item">
        <span class="label">
          <GamIcon :name="GamIconName.GIANT_CHESS" />
          {{
            location.giantChessPieces
              ? localize('locations.detail.about.info.numOfGiantChessBoardsPieces')
              : localize('locations.detail.about.info.numOfGiantChess')
          }}
        </span>
        <span class="value">
          <GamIcon :name="GamIconName.CHECK" class="check" />
          {{ location.giantChessBoardCount || 'Some' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { DetailLocationDto } from '@/core/data/location/location.interface';
import { LocationChessFeature } from '@/core/data/location/location.type';
import { localize } from '@/core/gambits';
import GamIcon from '@/views/components/GamIcon.vue';
import { GamIconName } from '@/views/composables/constants/components/gamIcon.constants';

interface Props {
  location: DetailLocationDto;
}

const { location } = defineProps<Props>();
</script>

<style scoped lang="scss">
hr {
  width: 100%;
  border: none;
  height: 1px;
  background: var(--color-white-10);
  margin: 0;
}

.sub-head {
  h4 {
    margin: 0;
  }

  hr {
    width: 100%;
    margin: var(--spacing-l) 0;
    border: none;
    height: 1px;
    background: var(--color-white-10);
  }
}

.value,
.info-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.label {
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: var(--spacing-l);
  padding-left: var(--spacing-md);
}

.value {
  width: 5.25rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-md);
}

.section-title {
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-white);
  margin-bottom: 0.75rem;
}

.additional-info {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
  margin-top: 0.75rem;
  padding-bottom: 0.75rem;
}
</style>

<style lang="scss">
.check path {
  fill: var(--color-pink) !important;
}
</style>
